import React from 'react'
class Footer extends React.Component {

    render = () => {
        return(
            <footer>
          <ul className="footer">
            <li>built with:</li>
            <li>
              <a className="nonText" target="_blank" rel="noopener noreferrer" href="http://code.visualstudio.com"><img src="/images/vscode.png"
                title="Visual Studio Code" alt="Visual Studio Code"/></a>
            </li>
            <li>
              <a className="nonText" target="_blank" rel="noopener noreferrer" href="https://reactjs.org/"><img src="/images/react.png"
                title="React – A JavaScript library for building user interfaces" alt="React – A JavaScript library for building user interfaces" /></a>
            </li>
            <li>
              <a className="nonText" target="_blank" rel="noopener noreferrer" href="https://www.npmjs.com/"><img src="/images/npm.png" title="Node Package Manager: Build amazing things" alt="Node Package Manager: Build amazing things"/></a>
            </li>
            {/* <li>
              <a target="_blank" rel="noopener noreferrer" href="https://nodejs.com"><img src="/images/node.png"
                title="Node.js® is a JavaScript runtime built on Chrome's V8 JavaScript engine" alt="Node.js® is a JavaScript runtime built on Chrome's V8 JavaScript engine"/></a>
            </li> */}
            <li>
              <a className="nonText" target="_blank" rel="noopener noreferrer" href="http://sass-lang.com/"><img src="/images/sass.png"
                title="Syntactically Awesome Style Sheets" alt="Syntactically Awesome Style Sheets"/></a>
            </li>
            <li>
              <a className="nonText" target="_blank" rel="noopener noreferrer" href="http://fontawesome.io/"> <img src="/images/fontawesome.png"
                title="The iconic font and CSS toolkit" alt="The iconic font and CSS toolkit"/></a>
            </li>
            <li>
              <a className="nonText" target="_blank" rel="noopener noreferrer" href="https://photoswipe.com/"> <img src="/images/photoswipe.png"
                title="Photoswipe: javaScript gallery, no dependencies" alt="Photoswipe: javaScript gallery, no dependencies"/></a>
            </li>
            <li>© 2019 <a href="mailto:sweaver2112@gmail.com"><span>sweaver2112</span></a></li>
          </ul>
        </footer>
        )
    }

}
export default Footer